export const dataHooks = {
  toggle: 'checkToggle-toggle',
  tooltip: 'checkToggle-tooltip',
};

export const SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
} as const;

export const SKIN = {
  STANDARD: 'standard',
  SUCCESS: 'success',
} as const;
